<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import { Icon } from "@iconify/vue2";

let user = JSON.parse(localStorage.getItem("user"));
let token = user.token;

export default {
  page: {
    title: "Otel Listesi",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Icon },
  data() {
    return {
      isBusy: false,
      isButton: false,
      title: "Otel Listesi",
      items: [
        {
          text: "RTS",
          href: "/",
        },
        {
          text: "Otel Listesi",
          active: true,
        },
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: 0,
      brand_name: "",
      fields: [
        { key: "company_name", label: "Otel Adı", sortable: true },
        {
          key: "hotel_address",
          label: "Otel Adresi",
          sortable: true,
          tdClass: "multiline-column",
        },
        { key: "hotel_email", label: "Otel E-posta", sortable: true },
        { key: "hotel_phone", label: "Otel Telefon", sortable: true },
        { key: "updated_at", label: "Güncellenme Tarihi", sortable: true },
        { key: "actions", label: "İşlemler" },
      ],
    };
  },
  methods: {
    sorgula() {
      this.$refs.dataTable.refresh();
    },
    getData(ctx, callback) {
      this.isBusy = true;
      const params = "?page=" + ctx.currentPage;
      const data = {
        name: this.brand_name ? this.brand_name : "",
      }
      axios
        .post(process.env.VUE_APP_BASEURL + "/hotel/filter" + params, data, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          if (response.data) {
            const items = response.data.data;
            this.totalRows = response.data.meta.total;
            this.perPage = response.data.meta.per_page;
            callback(items);
          }
        })
        .catch((error) => {
          callback([]);
          console.error("Veri yüklenirken bir hata oluştu:", error);
        });
        this.isBusy = false;
      return;
    },
    onPageChange(newPage) {
      this.currentPage = newPage;
    },
    editHotel(index) {
      this.$router.push('/hotel/edit/' + index);
    },
    deleteHotel(index) {
      this.isButton = true;
      const api_url = process.env.VUE_APP_BASEURL + '/hotel/' + index;
      axios
        .delete(api_url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(() => {
          this.$refs.dataTable.refresh();
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.isButton = false;
        })
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="sorgula">
              <div class="row">

                <div class="col-12">
                  <div class="form-group mb-3">
                    <label for="email">Otel Adı</label>
                    <input type="text" v-model="brand_name" class="form-control" />
                  </div>
                </div>

                <div class="col-12">
                  <div class="d-flex justify-content-end align-items-center">
                    <button type="submit" class="btn btn-primary px-4">Ara</button>
                  </div>
                </div>

              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div
                class="col-12 d-flex justify-content-between align-items-center mb-3"
              >
                <h4 class="card-title m-0">Otel Listesi</h4>
                <router-link to="/hotel/add" class="btn btn-primary">
                  <Icon icon="lucide:plus-circle" class="mr-1" /> Otel Ekle
                </router-link>
              </div>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                ref="dataTable" 
                :items="getData"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :busy="isBusy"
                :current-page="currentPage"
              >
                <template #table-busy>
                  <div
                    class="d-flex flex-column align-items-center justify-content-center gap-1 my-2"
                  >
                    <Icon
                      icon="lucide:loader"
                      class="spinner-rotate"
                      :style="{ fontSize: '72px' }"
                    />
                  </div>
                </template>
                <template #cell(updated_at)="data">
                  {{ data.item.updated_at | moment("DD.MM.YYYY HH:mm") }}
                </template>
                <template v-slot:cell(actions)="data">
                  <button
                    @click="editHotel(data.item.id)"
                    :disabled="isButton"
                    class="btn btn-sm btn-secondary"
                  >
                    Düzenle
                  </button>
                  <button
                    @click="deleteHotel(data.item.id)"
                    class="btn btn-sm btn-danger ml-2"
                    :disabled="isButton"
                  >
                    Sil
                  </button>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      @change="onPageChange"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.multiline-column {
  width: 20%;
  white-space: normal !important;
}
</style>
